import { useMemo } from 'react'
import CheckIcon from '@mui/icons-material/Check'
import { Button, Tooltip } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import { DropdownContentProps } from './dropdown-content'
import * as css from '../styles'

const ContentIdButton = ({ id, categoryText }) => {
  const templateState = useSelector((state: any) => state.Template, shallowEqual)
  const templateFields =
    templateState.templateFields.map(fieldId => templateState.templateFieldsById[fieldId]) || []
  const templateFieldsets = templateState.fieldsets

  const hasContentIdField = useMemo(() => {
    const creativeFieldsIds = templateFields
      .filter(templateField => templateField?.field?.governance_type === 'creative')
      .map(templateField => templateField.field.id)

    return templateFieldsets.some(fieldset =>
      fieldset.fields.some(
        field => field.classification?.category_id === id && creativeFieldsIds.includes(field.id),
      ),
    )
  }, [templateFields, templateFieldsets, id])

  return (
    <Tooltip
      title={
        hasContentIdField
          ? ''
          : 'Add a Content Comprehension field to this template to enable Content ID'
      }
      placement="top"
      enterDelay={250}
    >
      <span>
        <Button
          key={id}
          disabled={!hasContentIdField}
          variant="outlined"
          endIcon={<CheckIcon sx={{ width: 20 }} />}
          sx={css.buttonSxProps(hasContentIdField)}
        >
          {categoryText}
        </Button>
      </span>
    </Tooltip>
  )
}

interface ActionsProps {
  classifications: Pick<DropdownContentProps, 'classifications'>['classifications']
  selected: Pick<DropdownContentProps, 'selected'>['selected']
  toggleClassification: Pick<DropdownContentProps, 'toggleClassification'>['toggleClassification']
}

export const Actions = ({ classifications, toggleClassification, selected }: ActionsProps) => {
  return (
    <css.ActionsContainer>
      <css.ClassificationsContainer>
        {classifications?.map(({ id, categoryText, categoryKey }) =>
          categoryKey === 'content_id' ? (
            <ContentIdButton key={id} id={id} categoryText={categoryText} />
          ) : (
            <Button
              key={id}
              variant="outlined"
              onClick={() => {
                toggleClassification(id)
              }}
              endIcon={<CheckIcon sx={{ width: 20 }} />}
              sx={css.buttonSxProps(selected[id])}
            >
              {categoryText}
            </Button>
          ),
        )}
      </css.ClassificationsContainer>
    </css.ActionsContainer>
  )
}
